import React, { useEffect, useState } from "react";
import Header from "../common/Header";
import PageContainer from "../common/PageContainer";
import Tab from "../common/Tab/Tab";
import TabPage from "../common/Tab/TabPage";
import SearchBar from "../common/SearchBar";
import uniqid from "uniqid";
import RouteProtection from "../common/RouteProtection";
import RoomList from "./RoomList";
import { useQuery } from "@tanstack/react-query";
import { fetchWithToken } from "../../functions/fetch";
import { addSearchedField } from "../../functions/room";
import OverviewPage from "./OverviewPage";

const RoomPage = () => {
  const texts = ["房源總覽", "全部房間", "已出租", "未出租"];
  const [tabIndex, setTabIndex] = useState(0);
  const [unfilteredRooms, setUnfilteredRooms] = useState([]);
  const [filteredRooms, setFilteredRooms] = useState([]);
  const [rentedRooms, setRentedRooms] = useState([]);
  const [notRentedRooms, setNotRentedRooms] = useState([]);

  const pages = [
    <OverviewPage key={uniqid()} />,
    <RoomList key={uniqid()} rooms={filteredRooms} />,
    <RoomList key={uniqid()} rooms={filteredRooms} />,
    <RoomList key={uniqid()} rooms={filteredRooms} />,
  ];

  const fetchRoom = async () => {
    const res = await fetchWithToken(
      "GET",
      `${process.env.REACT_APP_BACKEND_HOST}/api/room`,
    );
    const { rooms } = res;

    addSearchedField(rooms);

    const newRentedRooms = rooms.filter((room) => room.renters !== null);
    const newNotRentedRooms = rooms.filter((room) => room.renters === null);
    setRentedRooms(newRentedRooms);
    setNotRentedRooms(newNotRentedRooms);

    const options = [rooms, rooms, newRentedRooms, newNotRentedRooms];

    // set value by tabIndex
    setUnfilteredRooms(options[tabIndex]);
    setFilteredRooms(options[tabIndex]);

    return rooms;
  };

  const { data: allRooms } = useQuery({
    queryKey: ["rooms"],
    queryFn: fetchRoom,
    initialData: [],
  });

  useEffect(() => {
    const options = [[], allRooms, rentedRooms, notRentedRooms];
    setUnfilteredRooms(options[tabIndex]);
    setFilteredRooms(options[tabIndex]);
  }, [tabIndex]);

  return (
    <>
      <Header />
      <RouteProtection />
      <PageContainer>
        <div className="flex justify-between items-center">
          <Tab
            texts={texts}
            tabIndex={tabIndex}
            setTabIndex={setTabIndex}
            gridCol="grid-cols-[repeat(4,min-content)]"
          />
          <SearchBar items={unfilteredRooms} setFunction={setFilteredRooms} />
        </div>
        <TabPage pages={pages} tabIndex={tabIndex} />
      </PageContainer>
    </>
  );
};

export default RoomPage;
